import { __t } from '@/lib/helpers.js'
import trialMode from '@/router/guards/trial-mode.js'
import { defineAsyncComponent } from 'vue'

import { getSubRoutes } from '@/router/routes/business/settings/subscription.js'

export default [
  {
    path: '/subscription-mobile',
    name: 'subscription-mobile',
    meta: {
      title: __t('routes.settings.subscription.title'),
      subtitle: __t('routes.settings.subscription.subtitle'),
      mobile: true,
      useSmartlook: true,
    },
    component: defineAsyncComponent(() => import('@/views/subscription-mobile/views/index.vue')),
    children: [
      ...getSubRoutes({ mobile: true }),
    ],
    beforeEnter: trialMode({ mobile: true }),
  },
  {
    path: '/subscription-mobile-error',
    name: 'subscription-mobile-error',
    component: defineAsyncComponent(() => import('@/views/subscription-mobile/views/error.vue')),
  },
]
